// ============================================================================
// sheep.dailys.index — the sheep daily hub, off its own mount effect
// ============================================================================
// Two obligations, and both were already presenter-owned. Nothing on this
// surface ever arrived as an App prop: SheepEntry mounts `<SheepDailysView />`
// with none, and `sheepdailys` sits in the noFormerEagerCohort of
// tests/fixtures/former-eager-dependencies.json — it consumes no result of any
// of the five formerly-eager global reads. So this localization has NO frozen
// consumer list to retire from, unlike its layer counterpart; what moved is the
// hub's own two reads, out of one mount effect and into the catalog.
//
//   sheep.dailys.list         the full-history page sequence. Page size,
//                             deleted_at filter and date/submitted_at DESC
//                             order unchanged; only the cursor's owner moved.
//                             `reload` is a page KEY param so Retry starts a new
//                             complete sequence rather than same-key refetching
//                             a partial list.
//   sheep.dailys.formInputs   the edit form's cattle_feed_inputs list. Separate
//                             from the list because it is FAIL-SOFT and always
//                             was: the effect it replaces swallowed its error
//                             and only set state `if (data)`, so an input outage
//                             costs the dropdowns their fresh options and never
//                             blanks the history.
//
// The herd_scope narrowing stayed in the presenter. It decides which loaded rows
// a sheep flock may CHOOSE; the unfiltered array is what save-time `.find()`
// resolves a historical inactive feed against, which cattle_sheep_inputs_
// consistency pins.
//
// Saved views are not an obligation here for the same reason they are not one on
// layer.dailys.index: useSavedViewsData is a shared sidecar owner for every
// surface with a picker, and this hub already used it.
//
// The record sibling sheep.dailys.detail migrated separately at 75581eba and is
// untouched — its resource is keyed by recordId and shares nothing with these.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'sheep.dailys.index',
  obligations: Object.freeze([
    Object.freeze({id: 'sheep.dailys.list', owner: 'permanent'}),
    Object.freeze({id: 'sheep.dailys.formInputs', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
